import { object, string } from "yup";

export type MarkRenewalAsPaid = {
  description?: string;
};

export const defaultValues: MarkRenewalAsPaid = {
  description: undefined,
};

export const markRenewalAsPaidValidator = object({
  description: string()
    .optional()
    .trim()
    .max(255, "Settlement description must be at most 255 characters"),
});
